import { useContent } from '../content/ContentContext.jsx'
import { Em } from '../components/Em.jsx'
import { Icon } from '../components/Icon.jsx'
import { SectionNum } from '../components/SectionNum.jsx'

function DisciplineBlock({ b }) {
  return (
    <div className="disc-block">
      <div className="dl">
        <div className="didx">{b.idx}</div>
        <div className="dicon">
          <Icon name={b.icon} size={30} stroke={1.4} />
        </div>
        <h3>{b.title}</h3>
        <p className="dintro">{b.intro}</p>
        <p className="dkeys">{b.keywords}</p>
        <div className="dcat caption">{b.category}</div>
      </div>
      <div>
        <div className="dgrid">
          {b.items.map((it) => (
            <div className="ditem" key={it.code}>
              <div className="dcode">{it.code}</div>
              <div className="dtitle">
                {it.title} — {it.tag}
              </div>
              <div className="dnote">{it.note}</div>
            </div>
          ))}
        </div>
        <div className="dclose">{b.closing}</div>
      </div>
    </div>
  )
}

export function DisciplinesSection() {
  const { content } = useContent()
  const d = content.disciplines
  return (
    <section className="section disc" id="sec-disciplines">
      <SectionNum sectionKey="disciplines" />
      <h2>
        <Em pre={d.pre} em={d.em} post={d.post} />
      </h2>
      {d.blocks.map((b) => (
        <DisciplineBlock b={b} key={b.idx} />
      ))}
    </section>
  )
}
